import Vue from 'vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import VueSweetalert2 from 'vue-sweetalert2'

Vue.component(FeatherIcon.name, FeatherIcon)
Vue.use(VueSweetalert2)
